import { AddAssetAction } from "../entities/AddAssetAction";

export const upsellToPaid = (assetAction: AddAssetAction) => {
    window.location.assign(`https://www.sermonmaker.net/upgrade-now/?upgradePath=${determineUpgradePath(assetAction)}&upgradeAction=${assetAction}`);
}

const determineUpgradePath = (action: AddAssetAction) => {
    let upgradePath = "Direct";
    if (action === AddAssetAction.AddDocUpload) {
        upgradePath = "Word";
    } else if (action === AddAssetAction.AddSoundCloudLink) {
        upgradePath = "SoundCloud";
    } else if (action === AddAssetAction.AddVimeoLink) {
        upgradePath = "Vimeo";
    } else if (action === AddAssetAction.AddYoutubeLink) {
        upgradePath = "YouTube";
    } else if (action === AddAssetAction.Template) {
        upgradePath = "Template";
    } else if (action === AddAssetAction.CreateCustomTemplate) {
        upgradePath = "Custom Template";
    } else if (action === AddAssetAction.CreateFromPremiumTemplate) {
        upgradePath = "Premium Template";
    } else if (action === AddAssetAction.ShareAsset) {
        upgradePath = "Share";
    } else if (action === AddAssetAction.Duplicate) {
        upgradePath = "Duplicate";
    }

    return upgradePath;
}